<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('tel1')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('tel10')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchleft">
                        <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                            <el-form-item :label="$t('tel6')" >
                                <el-input v-model="searchform.blurry" @click="$router.push('/user')" size="small" style="width:150px;"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('tel66')">
                                <el-select size="small" v-model="searchform.principalId" filterable :placeholder="$t('qxz')" style="width:130px;">
                                    <el-option :label="$t('qxz')" :value="null"></el-option>
                                    <el-option v-for="item in principallist"
                                        :key="item.id"
                                        :label="item.nickName"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-select>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>

                    <div class="top"></div>
                    <el-table :data="list" @selection-change="handleSelectionChange"
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="id" label="外呼编号"></el-table-column>
                        <el-table-column prop="number" label="外呼号码"></el-table-column>
                        <el-table-column prop="callType" label="外呼类型" width=150>
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.callType==1001" type="info" size="mini">坐席-人工外呼</el-tag>
                                <el-tag v-else-if="scope.row.callType==1002" type="success" size="mini">坐席-AI外呼-不转人工</el-tag>
                                <el-tag v-else-if="scope.row.callType==1003" type="warning" size="mini">坐席-AI外呼-接通转人工</el-tag>
                                <el-tag v-else-if="scope.row.callType==1004" type="danger" size="mini">坐席-AI外呼-智能转人工</el-tag>
                                <el-tag v-else-if="scope.row.callType==2001" type="info" size="mini">批量-预测外呼</el-tag>
                                <el-tag v-else-if="scope.row.callType==2002" type="success" size="mini">批量-AI外呼-不转人工</el-tag>
                                <el-tag v-else-if="scope.row.callType==2003" type="warning" size="mini">批量-AI外呼-接通转人工</el-tag>
                                <el-tag v-else-if="scope.row.callType==2004" type="danger" size="mini">批量-AI外呼-智能转人工</el-tag>
                                <el-tag v-else-if="scope.row.callType==2005" type="info" size="mini">批量-语音通知</el-tag>
                                <el-tag v-else-if="scope.row.callType==3001" type="primary" size="mini">视频外呼</el-tag>
                                <el-tag v-else type="default" size="mini">未知类型</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="callId" label="外呼ID"></el-table-column>
                        <el-table-column prop="taskId" label="任务ID"></el-table-column>
                        <el-table-column prop="statusDescription" label="外呼状态描述"></el-table-column>
                        <el-table-column prop="agentId" label="分配坐席ID"></el-table-column>
                        <el-table-column prop="userName" label="员工"></el-table-column>
                        <el-table-column prop="importTime" label="导入时间"></el-table-column>
                        <el-table-column prop="callBeginTime" label="拨号时间"></el-table-column>
                        <el-table-column prop="answerTime" label="接通时间"></el-table-column>
                        <el-table-column prop="transferTime" label="转接人工时间"></el-table-column>
                        <el-table-column prop="speakingTime" label="AI通话时长"></el-table-column>
                        <el-table-column prop="agentSpeakingTime" label="人工通话时长"></el-table-column>
                        <el-table-column prop="intentDescription" label="意向说明"></el-table-column>
                        <el-table-column prop="hangupType" label="挂机方式">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.hangupType==1" type="info" size="mini">AI挂机</el-tag>
                                <el-tag v-if="scope.row.hangupType==2" type="info" size="mini">坐席挂机</el-tag>
                                <el-tag v-if="scope.row.hangupType==3" type="info" size="mini">客户挂机</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="chats" label="对话记录"></el-table-column>
                        <el-table-column prop="interceptReason" label="拦截原因"></el-table-column>
                    </el-table>
                    <div class="page">
                            <el-pagination
                                @size-change="handchange"
                                @current-change="currentchange"
                                :current-page.sync="currentPage2"
                                :page-sizes="[10, 20, 50, 100, 200, 400]"
                                :page-size = "pageSize"
                                layout="sizes, prev, pager, next"
                                :total="total">
                            </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                searchform: {
                    blurry: "",
                    principalId: "",
                },
                total: 1,
                pageNo: 1,
                pageSize: 10,
                loading: false,
                list: [],
                status:null,
                principallist:[],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getprincipal()
            this.getList()
        },
        methods: {
            getprincipal() {
                _api.get(apiurl.users, {
                    roleId: 5,
                }).then(res => {
                    this.principallist = res.content
                })
            },
            
            getList() {
                this.loading = true
                _api.get(apiurl.groupbusySuccess, {
                    page: this.pageNo,
                    size: this.pageSize,
                    blurry: this.searchform.blurry,
                    principalId: this.searchform.principalId,
                }).then(res => {
                    this.loading = false
                    this.blurry=null
                    this.list = res.data.data
                    this.total = res.data.totalCount
                })
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>